let configRequestAdapter;
let configRestRequestAdapter;

/**
 * Переопределение сетевого адаптера для фоновой отправки метрик
 * @param {String} requestAdapter сетевой адаптер для фоновой отправки метрик
 * @return {void}
 */
export const setRequestAdapter = requestAdapter => {
  configRequestAdapter = requestAdapter;
};
export const getRequestAdapter = () => {
  return configRequestAdapter;
};

/**
 * Переопределение сетевого адаптера для финальной отправки метрик
 * @param {String} requestAdapter сетевой адаптер для финальной отправки метрик
 * @return {void}
 */
export const setRestRequestAdapter = requestAdapter => {
  configRestRequestAdapter = requestAdapter;
};
export const getRestRequestAdapter = () => {
  return configRestRequestAdapter;
};